<mbsc-datepicker
    [startInput]="start"
    [endInput]="end"
    [min]="minDateJS"
    [max]="maxDateJS"
    [touchUi]="isMobile"
    [showRangeLabels]="showRangeLabels"
    [dayNamesShort]="localeInfo.AbbreviatedDayNames"
    [monthNames]="localeInfo.MonthNames"
    [monthNamesShort]="localeInfo.AbbreviatedMonthNames"
    [dayNamesMin]="localeInfo.AbbreviatedDayNames"
    [firstDay]="firstDayOfWeek"
    [rtl]="localeInfo.RightToLeft"
    themeVariant="light"
    select="range"
    (onChange)="DateChangeEvent($event)"
    (onClose)="DatePickerCloseEvent($event)"></mbsc-datepicker>
<div class="d-flex align-items-baseline gap-space-6 flex-wrap text-wrap">
    <p class="typography-title-large">
        <ng-content></ng-content>
    </p>

    <div
        #start
        (click)="OpenDatePicker(RangeLabelValue.Start)"
        (change)="$event.stopPropagation()">
        <lib-button
            qaTag="date-range-start-selector-button"
            [kind]="ButtonKind.Link"
            [size]="ButtonSize.XLarge"
            [suffixIcon]="Icon.Common.CaretDown">
            <ng-container label>{{ startDate | formatDate: 'short' }}</ng-container>
        </lib-button>
    </div>

    <p class="typography-title-large">
        <ng-content select="[separator]"></ng-content>
    </p>
    <div
        #end
        (click)="OpenDatePicker(RangeLabelValue.End)"
        (change)="$event.stopPropagation()">
        <lib-button
            qaTag="date-range-end-selector-button"
            [kind]="ButtonKind.Link"
            [size]="ButtonSize.XLarge"
            [suffixIcon]="Icon.Common.CaretDown">
            <ng-container label>{{ endDate | formatDate: 'short' }}</ng-container>
        </lib-button>
    </div>
</div>
